<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="" class="fn-left">
            <el-input
              v-model="listQuery.mobile"
              placeholder="手机号码"
            />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetRecordLists">查询</el-button>
          </el-form-item>

        </el-form>

      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="家长ID" prop="account_id" align="center" />
        <el-table-column label="手机号码" prop="mobile" align="center" />
        <el-table-column label="校区" prop="mobile" align="center">
          <template slot-scope="{row}">
            <p v-for="(sub,subIndex) in row.sub_list" :key="'sub'+subIndex">
              <span>{{ sub.tll_account_id }}</span><span>{{ sub.sub_name }}</span><span>{{ sub.shop_name }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="优豆" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnRecord(row.account_id)">{{ row.value || 0 }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" style="color:red!important" @click="fnUpdateRecord(row.account_id)">增减优豆</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="dialogAddRecordVisible" title="增减优豆" width="400px">
      <add-y-coin ref="adddRecordDialog" :key="dialogAddRecordKey" :master-id="currentMasterId" @successCBK="fnAddSuccess()" />
    </el-dialog>
    <el-dialog class="flow_list_page" :visible.sync="dialogReocordVisable" title="优豆流水" width="60%">
      <el-table :key="recordKey" :data="recordLists" border stripe>
        <el-table-column label="时间" prop="create_time" align="center" />
        <!-- <el-table-column label="业务" prop="mobile" align="center" /> -->
        <el-table-column label="校区" prop="shop_name" align="center" />
        <el-table-column label="优豆" prop="value" align="center" />
        <el-table-column label="原因" prop="rule_name" align="center" />
        <el-table-column label="操作人" prop="editor_name" align="center" />
      </el-table>
      <div class="fn-right table-header-right ">
        <el-pagination
          :current-page.sync="recordListQuery.p"
          :page-size="recordListQuery.limit"
          layout="pager, prev, slot, next"
          prev-text="上一页"
          next-text="下一页"
          :total="recordListQuery.total"
          @current-change="fnGetRecordInfo()"
        >
          <!-- <div class="chax">
            {{ recordListQuery.p }}/{{
              recordListQuery.total > 0 ? Math.ceil(recordListQuery / recordListQuery.limit) : 1
            }}
          </div> -->
        </el-pagination>
      </div>
    </el-dialog>

  </div>

</template>
<script>

// import Select from '@/components/Select'
import AddYCoin from './AddYCoin'
// import commondata from '@/utils/commondata'

export default {
  name: 'YcoinExchangeRecordManage',
  components: {
    // Select
    // AddExchangeRecord
    AddYCoin
  },
  data() {
    return {
      selectList: [],
      lists: [],
      dialogAddRecordKey: 0,
      dialogAddRecordVisible: false,
      currentMasterId: '',
      tableKey: 0,
      recordLists: [],
      recordKey: 0,
      dialogReocordVisable: false,
      listQuery: {
        mobile: ''

      },
      recordListQuery: {
        p: 1,
        total: 0,
        limit: 10,
        master_id: ''
      }
    }
  },
  created() {
    this.fnGetRecordLists()
    // this.fnGetSelectList()
  },
  methods: {
    changeType: function() {

    },
    search: function() {

    },
    fnGetRecordLists: function() {
      this.$http.masterPointList(this.listQuery).then(res => {
        if (res.data.account_id) {
          this.tableKey++
          res.data.mobile = this.listQuery.mobile
          this.lists = [res.data]
        } else {
          this.lists = []
        }
      })
    },
    fnUpdateRecord: function(id) {
      this.currentMasterId = id
      this.dialogAddRecordKey += 1
      this.dialogAddRecordVisible = true
    },
    fnAddSuccess: function() {
      this.dialogAddRecordVisible = false
      this.fnGetRecordLists()
    },
    fnAddRecord: function() {
      this.currentFood = ''
      this.dialogAddRecordKey += 1
      this.dialogAddRecordVisible = true
    },
    fnRecord: function(master_id) {
      this.recordListQuery.master_id = master_id
      this.fnGetRecordInfo()
    },
    fnGetRecordInfo() {
      this.$http.masterPointFlow(this.recordListQuery).then(res => {
        this.recordLists = res.data.list
        this.recordListQuery.total = parseInt(res.data.count)
        this.dialogReocordVisable = true
      })
    }
  }
}
</script>
<style lang="scss">
  .flow_list_page .el-dialog__body {
    background-color:#5b74ab ;
    padding-bottom: 45px!important;
  }

  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
